{% block sw_cms_element_acris_blog_author_date_config %}
    <div class="sw-cms-el-config-acris-blog-author-date">
        <mt-select hide-clearable-button
                   :label="$tc('acris-blog.elements.blogAuthorDate.config.label.layout')"
                   v-model="element.config.layout.value"
                   :options="layoutOptions">
        </mt-select>
    </div>
{% endblock %}
